<style lang="scss" scoped>

</style>

<template>
    <div>
        <div v-if="isProfileSelected" class="card">
            <div class="list-group list-group-flush list-group-hoverable">
                <div v-if="disabled === false" class="list-group-item">
                    <router-link  to="/profiles">
                        <ProfileItem :profile="profile" :show-details="false" ></ProfileItem>
                    </router-link>
                </div>
                <div v-else class="list-group-item">
                    <ProfileItem :profile="profile" :show-details="false" :selectYear="true"></ProfileItem>
                </div>
            </div>
        </div>
        <router-link v-else to="/profiles" class="btn btn-white w-100">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon text-green" width="24" height="24"
            viewBox="2 2 20 20" stroke-width="2.5" stroke="currentColor" fill="none" stroke-linecap="round"
            stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M8 5v10a1 1 0 0 0 1 1h10" />
                <path d="M5 8h10a1 1 0 0 1 1 1v10" />
            </svg>
            Bitte Schlag wählen
        </router-link>
    </div>
</template>

<script>

import ProfileItem from '@/components/profile/ProfileItem.vue';

export default {
    name: 'ProfileSelect',
    components: {
         ProfileItem
    },
    inject: [
        'state',
        'utils'
    ],
    props: {
        profile: {
            type: Object,
            default: null
        },
        disabled: {
          type: Boolean,
          default: false
        }
    },
    data: function () {
        return {
            waterPoint: null,
            loading: false
        }
    },
    computed: {
        isProfileSelected: function () {
            return !this.utils.isDataTypeFalse(this.profile);
        }
    },  
    methods: {
    
    }
}

</script>